<template>
	<div class="home">
		<div class="home_con_1">
			<img class="home_con_1_img" :src="bannerImage" />
		</div>
		<div class="home_con_2">
			<NewsList />
		</div>
	</div>
</template>

<script>
import { bannerApi, baseImgUrl } from '../netTool/api';
import NewsList from '../components/newsList.vue';

export default {
	name: 'Home',
	components: {
		NewsList
	},
	data() {
		return {
			bannerImage: ''
		};
	},
	async mounted() {
		try {
			const navId = 6;
			const response = await bannerApi.getBanner(navId);
			if (response.success) {
				this.bannerImage = baseImgUrl + response.banner.image_url;
			}
		} catch (error) {}
	}
};
</script>

<style scoped>
.home {
	--base-width: 1920;
	--scale-factor: 2.5;

	width: 100%;
	overflow: hidden;
}

.home_con_1_img {
	width: 100%;
	height: auto;
	background-repeat: no-repeat;
	background-position: center;
}

.home_con_2 {
	background-color: #f8f8f8;
}
</style>
